import { baseThemeValues } from 'constants/common';

const counterFont = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '11px',
  fontWeight: 400,
};

export const pspParameterFormTheme = {
  counter: {
    base: {
      ...counterFont,
      text: 'palette.tertiary.50',
    },
    warn: {
      ...counterFont,
      text: 'palette.warning.50',
    },
  },
};
